/**
 * The family's chevron mark on Pascal's amber-brown (#8A5A14): three white chevrons rising in opacity, the geometry of
 * the suite's mark, distinct from Olivia's olive and Valentin's indigo.
 *
 * PROVENANCE: C:\Olivia\web\src\components\Mark.tsx @ f92475e, copied 2026-10-12. CHANGES: Pascal's colour.
 */

export function Mark({ size = 28, label }: { size?: number; label: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label={label}>
      <rect width="64" height="64" rx="14" fill="#8A5A14" />
      <g fill="none" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="18,44 32,32 46,44" opacity="0.45" />
        <polyline points="18,34 32,22 46,34" opacity="0.7" />
        <polyline points="18,24 32,12 46,24" />
      </g>
    </svg>
  )
}
